import { Post } from "@/types/Post";
import { Status } from "~/types/CustomFetch";
import { mapResultToPosts } from "~/utils/storyblok/mapResultToPosts";

export const useSearchPosts = (
  searchTerm: Ref<string>,
  searchTag?: Ref<string>
) => {
  const status: Ref<Status> = ref("idle");
  const { storyblokVersion } = useRuntimeConfig().public;

  const posts: Ref<Post[]> = ref([]);
  const page = ref(1);
  const totalPages = ref(0);
  const nFound = ref(0);

  let timer: any;

  watch(
    [page, searchTerm],
    () => {
      status.value = "pending";

      clearTimeout(timer);
      timer = setTimeout(() => {
        useStoryblokApi()
          .getStories(
            (() => {
              const options: any = {
                version: storyblokVersion as "draft" | "published",
                content_type: "post",
                page: page.value,
                per_page: 12,
                resolve_links: "url",
                resolve_relations: ["post.author", "post.specialist"],
                filter_query: {
                  postType: {
                    in: "post",
                  },
                },
              };

              if (searchTerm.value) {
                options.search_term = searchTerm.value;
                options.filter_query.title = {
                  like: `*${searchTerm.value}*`,
                };
              } else if (searchTag?.value) {
                options.with_tag = searchTag.value;
                options.sort_by = "first_published_at:desc";
              }

              return options;
            })()
          )
          .then((r) => {
            const mappedResult = mapResultToPosts(r);

            posts.value = mappedResult.posts;
            totalPages.value = mappedResult.totalPages;
            nFound.value = r.total;

            status.value = "success";
          })
          .catch(() => {
            status.value = "error";
          });
      }, 500);
    },
    {
      immediate: searchTerm.value || searchTag?.value ? true : false,
    }
  );

  return {
    status,
    posts,
    page,
    totalPages,
    nFound,
  };
};
